module.exports = __webpack_public_path__ + "assets/img/diagram02.95c47611.svg";